var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.lastAdmin)?_c('div',{staticClass:"button",on:{"click":_vm.joinOrLeave}},[_c('div',{staticClass:"supel"},[_c('PlusIcon')],1),_vm._v(" "+_vm._s(_vm.chat.subscriber ? _vm.$t("messenger.leave") : _vm.$t("messenger.join"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }